import Icon from '../components/Icon.vue'

Icon.register({
  rss: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128.1 416C128.1 451.3 99.4 480 64 480S0 451.3 0 416 28.7 351.9 64 351.9 128.1 380.6 128.1 416zM303.7 463.2C295.4 308.6 171.6 184.6 16.8 176.3 7.7 175.8 0 183.1 0 192.3V240.3C0 248.7 6.5 255.8 14.9 256.3 126.7 263.6 216.4 353 223.7 465.1 224.2 473.5 231.3 480 239.7 480H287.7C296.9 480 304.2 472.3 303.7 463.2zM448 463.5C439.6 229.7 251.5 40.4 16.5 32 7.5 31.7 0 39 0 48V96.1C0 104.7 6.8 111.7 15.5 112.1 206.6 119.9 360.1 273.4 367.9 464.5 368.3 473.2 375.3 480 383.9 480H432C441 480 448.3 472.5 448 463.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rss.js
// module id = mGTy
// module chunks = 144